"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Section = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBMenuItem = require("../HBMenu/HBMenuItem");
var HBMenuSectionTitle = function HBMenuSectionTitle(_ref) {
  var item = _ref.item,
    size = _ref.size;
  return /*#__PURE__*/_react["default"].createElement(Section, {
    size: size
  }, /*#__PURE__*/_react["default"].createElement(SectionTitle, null, item.sectionTitle));
};
var _default = exports["default"] = HBMenuSectionTitle; // -------------------------------- Styles -------------------------------- //
var Section = exports.Section = (0, _styledComponents["default"])(_reactDropdownMenu.Label).withConfig({
  displayName: "HBMenuSectionTitle__Section",
  componentId: "sc-vjj5k6-0"
})(["", ";padding:0 20px;display:flex;align-items:center;"], _HBMenuItem.menuItemHeight);
var SectionTitle = _styledComponents["default"].span.withConfig({
  displayName: "HBMenuSectionTitle__SectionTitle",
  componentId: "sc-vjj5k6-1"
})(["font-size:14px;color:", ";text-transform:uppercase;"], _colors["default"].neutral600);
//# sourceMappingURL=HBMenuSectionTitle.js.map